/**
 * CZNA-1614 — the URL of an identifier at its source (VIAF, ISNI, ORCID,
 * Wikidata…), built from the 024 group's `uriTemplate` (e.g.
 * `"https://viaf.org/viaf/{id}"`) and the identifier typed in `$a`.
 *
 * It backs the form's "open at source" link only — the stored `$1` is kept in
 * step by `fillUriFromIdentifier`, which this does not touch.
 *
 * Returns `null` (no link) when:
 *  - there is no template, or it has no `{id}` placeholder;
 *  - the identifier is empty after trimming;
 *  - the result is not an absolute `http:` / `https:` URL — a template is
 *    customer-editable configuration, so a `javascript:` or `data:` one must
 *    never become a clickable link.
 *
 * The identifier is inserted `encodeURIComponent`-encoded, so `/`, `?`, `#`
 * or a space in it stay part of the identifier instead of reshaping the URL.
 */
var ID_PLACEHOLDER = '{id}';
var ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);
var buildSourceUrl = function (template, identifier) {
    var trimmedTemplate = (template !== null && template !== void 0 ? template : '').trim();
    var id = (identifier !== null && identifier !== void 0 ? identifier : '').trim();
    if (!trimmedTemplate.includes(ID_PLACEHOLDER) || !id) {
        return null;
    }
    var url = trimmedTemplate.split(ID_PLACEHOLDER).join(encodeURIComponent(id));
    try {
        return ALLOWED_PROTOCOLS.has(new URL(url).protocol) ? url : null;
    }
    catch (_a) {
        return null; // not an absolute URL
    }
};
export default buildSourceUrl;
